import { useEffect, useMemo, useState } from 'react';
import type { ConfigKind, ConfigValue } from '@/domain';
import { configService } from '@/services/configService';
import { mockStore } from '@/lib/mock-store';
import { isMockBackend } from '@/lib/supabase';

export function useCurrentConfig(kind?: ConfigKind): ConfigValue[] {
  const [rows, setRows] = useState<ConfigValue[]>([]);

  useEffect(() => {
    let alive = true;
    function refresh() {
      configService.listCurrent(kind).then((data) => {
        if (alive) setRows(data);
      });
    }
    refresh();
    if (isMockBackend) {
      return mockStore.subscribe(refresh);
    }
    return () => {
      alive = false;
    };
  }, [kind]);

  return rows;
}

export function useConfigValue(key: string): ConfigValue | null {
  const all = useCurrentConfig();
  return useMemo(() => all.find((v) => v.key === key) ?? null, [all, key]);
}

export function useConfigHistory(key: string): ConfigValue[] {
  const [rows, setRows] = useState<ConfigValue[]>([]);
  useEffect(() => {
    let alive = true;
    function refresh() {
      configService.history(key).then((data) => {
        if (alive) setRows(data);
      });
    }
    refresh();
    if (isMockBackend) return mockStore.subscribe(refresh);
    return () => {
      alive = false;
    };
  }, [key]);
  return rows;
}
